<template>
  <b-modal
    size="xl"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    id="folder-modal"
    :visible="showModal"
    @hidden="modalType == 'Recruiter' ||
          modalType == 'Panelists' ||
          modalType == 'User'
            ? closeModal()
            : closePanelCard(),
            $emit('close-modal')"
  >
    <b-overlay :show="showSpinner" rounded="sm">
      <div
        @click="
          modalType == 'Recruiter' ||
          modalType == 'Panelists' ||
          modalType == 'User'
            ? closeModal()
            : closePanelCard(),
            $emit('close-modal')
        "
        class="xMarkCancel"
        style="top: -26px; right: -26px"
      >
        <img src="../../assets/cross-round.svg" alt="" />
      </div>
      <div style="height: calc(100vh - 180px)">
        <div class="d-flex justify-content-between">
          <div class="tag-user">Tag {{ getModalHeading }}</div>

          <div class="search-bar-popup">
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
            <b-form-input
              class="search-input"
              :placeholder="'Search ' + getModalHeading"
              v-model.trim="searchUserGlobal"
              debounce="500"
              @update="getGlobalUsers"
              type="search"
            ></b-form-input>
          </div>
          <div style="width: 5%"></div>
        </div>
        <hr />

        <template v-if="searchUserGlobal.length == 0">
          <b-row>
            <b-col cols="5">
              <div style="height: calc(100vh - 220px)">
                <div
                  class="search-bar-popup-folders mr-3"
                  v-if="
                    modalType == 'Recruiter' ||
                    modalType == 'Panelists' ||
                    modalType == 'User'
                  "
                >
                  <img
                    class="searchicon"
                    src="../../assets/img/search-bar-icon.svg"
                    alt=""
                  />
                  <b-form-input
                    class="search-input"
                    placeholder="Search Folders"
                    v-model.trim="searchFolders"
                    @update="searchFolder"
                    debounce="500"
                    type="search"
                  ></b-form-input>
                </div>
                <div class="search-bar-popup-folders mr-3" v-else>
                  <img
                    class="searchicon"
                    src="../../assets/img/search-bar-icon.svg"
                    alt=""
                  />
                  <b-form-input
                    class="search-input"
                    placeholder="Search Folders"
                    v-model.trim="searchPan"
                    debounce="500"
                    @update="folderSearch"
                    type="search"
                  ></b-form-input>
                </div>
                <div
                  class="folders-left-container mt-2"
                  v-if="modalType == 'Recruiter' || modalType == 'Panelists'"
                >
                  <b-overlay :show="showLoader" rounded="sm" class="h-100">
                    <template v-if="folders.length > 0">
                      <div
                        v-for="(folder, index) in folders"
                        :key="index"
                        class="mb-2"
                      >
                        <FolderCard
                          :folder="folder"
                          :depth="5"
                          :level="1"
                          :folderSelectionState="folderSelectionState"
                          @update-folderup="updateFolderUp"
                          @check-folderID="checkFolderCard"
                          class="pointer"
                        />
                      </div>
                    </template>

                    <template v-else-if="!showLoader">
                      <div
                        class="
                          unselected-folder unselected-folder-text
                          d-flex
                          align-items-center
                          justify-content-center
                        "
                      >
                        No folder found
                      </div>
                    </template>
                  </b-overlay>
                </div>
                <div
                  class="folders-left-container mt-2"
                  v-else-if="modalType == 'selectpanel' || modalType == 'User'"
                >
                  <b-overlay :show="showLoader" rounded="sm" class="h-100">
                    <div v-if="foldersListPan.length !== 0">
                      <div
                        v-for="(panel, index) in foldersListPan"
                        :key="index"
                        class="mb-2"
                      >
                        <FolderCard
                          :folder="panel"
                          :depth="5"
                          :level="1"
                          @stop-spinner="showfolderspinner"
                          @selectPanelPath="getSelctedPanelist"
                          @update-folderup="updateFolderUp"
                          :folderSelectionState="folderSelectionState"
                          @check-folderID="checkFolderCard"
                          class="pointer"
                        />
                      </div>
                    </div>
                    <div
                      v-else-if="foldersListPan.length == 0 && !showLoader"
                      class="
                        folders-left-container
                        d-flex
                        align-items-center
                        justify-content-center
                        flex-column
                        h-100
                      "
                    >
                      <img src="../../assets/img/nofoldersearch.svg" alt="" />
                      <div class="mt-3 ml-3 wb-nocard-selected-font">
                        There are no folders available
                      </div>
                    </div>
                  </b-overlay>
                </div>
              </div>
            </b-col>
            <b-col
              cols="7"
              :class="{
                'd-flex  flex-column': checkEmptySelection,
              }"
            >
              <template v-if="checkEmptySelection">
                <div
                  class="
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    text-center
                  "
                  :class="
                    modalType == 'selectpanel' && finalPath != ''
                      ? 'empty-path-selection'
                      : modalType == 'selectpanel'
                      ? 'empty-selection-panel'
                      : 'empty-selction'
                  "
                >
                  <img
                    src="../../assets/img/createjd/nofolderselected.svg"
                    alt=""
                  />
                  <span class="teams-folder-text mt-3">
                    Please select the folder to add
                    {{ getModalHeading.toLowerCase() }}
                  </span>
                </div>
              </template>

              <template v-else>
                <div class="d-flex">
                  <div
                    v-if="modalType !== 'selectpanel' && folderUp.visible"
                    class="pointer"
                    @click="getFolderDetails(folderUp.folderID, false)"
                  >
                    <img src="../../assets/bckarrow.svg" alt="" />
                  </div>
                  <div
                    :class="
                      modalType !== 'selectpanel' && folderUp.visible
                        ? 'ml-3'
                        : ''
                    "
                  >
                    <img
                      src="../../assets/img/createjd/foldericon.svg"
                      alt=""
                    />
                    <span class="ml-2 active-folder">
                      {{ activeFolder.folderName }}
                    </span>
                  </div>
                </div>

                <div class="access-control-tabs mt-3">
                  <b-overlay :show="stopSpinner" rounded="sm">
                    <b-tabs content-class="mt-3">
                      <b-tab title="Folders">
                        <template
                          v-if="
                            activeFolder.folderCount > 0 ||
                            modalType == 'selectpanel' ||
                            modalType == 'User'
                          "
                        >
                          <div class="search-bar-popup w-100">
                            <img
                              class="searchicon"
                              src="../../assets/img/search-bar-icon.svg"
                              alt=""
                            />
                            <b-form-input
                              class="search-input"
                              :placeholder="
                                'Search Folders in ' + activeFolder.folderName
                              "
                              v-model.trim="searchSubFolder"
                              @update="findByFolder"
                              debounce="500"
                              type="search"
                            ></b-form-input>
                          </div>
                          <div
                            :class="
                              modalType == 'selectpanel' && finalPath != ''
                                ? 'path-folder-card mt-2'
                                : modalType == 'selectpanel'
                                ? 'folder-card-list mt-2'
                                : 'folder-content-list mt-2'
                            "
                            class="folder-content-list mt-2"
                          >
                            <template
                              v-if="activeFolder.childFolders !== undefined"
                            >
                              <div
                                class="folder-box mb-2 pointer"
                                v-for="(
                                  folder, index
                                ) in activeFolder.childFolders"
                                :key="index"
                                @click="getFolderDetails(folder.folderID)"
                              >
                                <div
                                  style="width: 40%"
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-start
                                  "
                                >
                                  <div>
                                    <img
                                      class="ml-3 mr-2"
                                      src="../../assets/img/createjd/foldericon.svg"
                                      alt=""
                                    />
                                    <span class="folder-list-name">{{
                                      folder.folderName
                                    }}</span>
                                  </div>
                                </div>
                                <div
                                  style="width: 50%"
                                  class="
                                    d-flex
                                    align-items-center
                                    justify-content-around
                                  "
                                >
                                  <div
                                    class="d-flex align-items-center"
                                    v-if="
                                      modalType == 'Recruiter' ||
                                      modalType == 'Panelists' ||
                                      modalType == 'User'
                                    "
                                  >
                                    <img
                                      class="mr-1"
                                      src="../../assets/img/createjd/childfolders.svg"
                                      alt=""
                                    />
                                    <span class="folder-label-text"
                                      >Folders :
                                      <span class="folder-count-text">{{
                                        folder.noOfFolders > 9
                                          ? folder.noOfFolders
                                          : "0" + folder.noOfFolders
                                      }}</span></span
                                    >
                                  </div>
                                  <div
                                    class="d-flex align-items-center"
                                    v-else-if="modalType == 'selectpanel'"
                                  >
                                    <img
                                      class="mr-1"
                                      src="../../assets/img/createjd/childfolders.svg"
                                      alt=""
                                    />
                                    <span class="folder-label-text"
                                      >Folders :
                                      <span class="folder-count-text">
                                        {{
                                          folder.childFolders.length > 9
                                            ? activeFolder.childFolders.length
                                            : "0" + folder.childFolders.length
                                        }}</span
                                      ></span
                                    >
                                  </div>
                                  <div
                                    class="d-flex align-items-center"
                                    v-if="
                                      modalType == 'Recruiter' ||
                                      modalType == 'Panelists' ||
                                      modalType == 'User'
                                    "
                                  >
                                    <img
                                      class="mr-1"
                                      src="../../assets/img/createjd/usersicon.svg"
                                      alt=""
                                    />
                                    <span class="folder-label-text"
                                      >Users :
                                      <span class="folder-count-text">{{
                                        folder.users > 9
                                          ? folder.users
                                          : "0" + folder.users
                                      }}</span></span
                                    >
                                  </div>
                                  <div
                                    class="d-flex align-items-center"
                                    v-else-if="modalType == 'selectpanel'"
                                  >
                                    <img
                                      class="mr-1"
                                      src="../../assets/img/createjd/usersicon.svg"
                                      alt=""
                                    />
                                    <span class="folder-label-text"
                                      >Users :
                                      <span class="folder-count-text">{{
                                        activeFolder.users.length > 9
                                          ? activeFolder.users.length
                                          : "0" + activeFolder.users.length
                                      }}</span></span
                                    >
                                  </div>
                                  <div>
                                    <img
                                      src="../../assets/img/createjd/goinfolder.svg"
                                      alt=""
                                    />
                                  </div>
                                </div>
                              </div>
                            </template>
                            <div
                              v-if="
                                activeFolder.childFolders.length == 0 &&
                                searchSubFolder != ''
                              "
                              class="
                                folder-box
                                unselected-folder-text
                                d-flex
                                align-items-center
                                justify-content-center
                              "
                            >
                              No folder found
                            </div>
                          </div>
                        </template>

                        <template v-else>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-center
                            "
                            style="height: calc(100vh - 330px)"
                          >
                            <img
                              src="../../assets/img/createjd/modalnofolder.svg"
                              alt=""
                            />
                          </div>
                        </template>
                      </b-tab>
                      <b-tab title="Users">
                        <template
                          v-if="
                            activeFolder.userCount > 0 ||
                            modalType === 'selectpanel' ||
                            modalType === 'User'
                          "
                        >
                          <div class="search-bar-popup w-100">
                            <img
                              class="searchicon"
                              src="../../assets/img/search-bar-icon.svg"
                              alt=""
                            />
                            <b-form-input
                              class="search-input"
                              :placeholder="
                                'Search Users in ' + activeFolder.folderName
                              "
                              v-model.trim="searchUser"
                              debounce="500"
                              @update="findByUser(activeFolder.folderID, true)"
                              type="search"
                            ></b-form-input>
                          </div>
                          <div class="table-main mt-2">
                            <table
                              :aria-describedby="'Folders'"
                              class="w-100 tp-reports-table"
                            >
                              <thead>
                                <tr>
                                  <th
                                    style="width: 10%"
                                    class="text-center"
                                    v-if="
                                      modalType == 'Recruiter' ||
                                      modalType == 'Panelists'
                                    "
                                  >
                                    <span v-if="activeFolder.users.length != 0">
                                      <b-form-checkbox
                                        size="sm"
                                        v-model="selectedParentFolders"
                                        :value="activeFolder.folderID"
                                        @input="checkSelectAll"
                                      ></b-form-checkbox>
                                    </span>
                                  </th>
                                  <th
                                    style="width: 30%"
                                    class="text-center table-data"
                                  >
                                    User Name
                                  </th>
                                  <th
                                    style="width: 30%"
                                    class="text-center table-data"
                                  >
                                    Email ID
                                  </th>
                                  <th
                                    style="width: 30%"
                                    class="text-center table-data"
                                  >
                                    Roles
                                  </th>
                                </tr>
                              </thead>

                              <tbody
                                :class="{
                                  'table-panel-fm': modalType === 'selectpanel',
                                  'table-panel-user': modalType === 'User',
                                  'table-finalpath':
                                    (modalType === 'selectpanel' ||
                                      modalType === 'User') &&
                                    finalPath !== '',
                                  'table-createjd':
                                    modalType !== 'selectpanel' &&
                                    modalType !== 'User',
                                }"
                              >
                                <div v-if="activeFolder.users.length > 0">
                                  <tr
                                    v-for="(user, index) in activeFolder.users"
                                    :key="index"
                                    :id="user.folderID + index"
                                    @click="
                                      modalType == 'selectpanel' ||
                                      modalType == 'User'
                                        ? addPanel(user)
                                        : ''
                                    "
                                    :class="[
                                      modalType === 'selectpanel'
                                        ? user.folderID ===
                                            selectedpanel.folderID &&
                                          user.panelID === selectedpanel.panelID
                                          ? 'fm-selcetd-class'
                                          : 'fm-deselect-class pointer'
                                        : '',
                                      modalType === 'User' &&
                                      user.userID === selectedUserDetails.userID
                                        ? 'fm-selcetd-class'
                                        : 'fm-deselect-class pointer',
                                    ]"
                                  >
                                    <td
                                      class="text-center table-data"
                                      style="width: 10%"
                                      v-if="
                                        modalType == 'Recruiter' ||
                                        modalType == 'Panelists'
                                      "
                                    >
                                      <div
                                        :style="{
                                          background: '#49BE9B',
                                        }"
                                        class="gridgreencolorDynamic mr-1"
                                      ></div>
                                      <b-form-checkbox
                                        size="sm"
                                        :value="convertJSONtoString(user)"
                                        v-model="selectedUsers"
                                        @change="
                                          checkUsers(
                                            activeFolder.users,
                                            user.folderID
                                          )
                                        "
                                      ></b-form-checkbox>
                                    </td>
                                    <td
                                      class="text-center table-data"
                                      v-if="
                                        modalType == 'Recruiter' ||
                                        modalType == 'Panelists'
                                      "
                                    >
                                      {{ user.username }}
                                    </td>
                                    <td class="text-center table-data" v-else>
                                      <div
                                        :style="{
                                          background: '#49BE9B',
                                        }"
                                        class="gridgreencolorDynamic mr-1"
                                      ></div>
                                      <span class="pl-3">
                                        {{ user.username }}
                                      </span>
                                    </td>
                                    <td class="text-center table-data">
                                      {{ user.email }}
                                    </td>
                                    <td
                                      class="
                                        text-center
                                        table-data
                                        text-truncate
                                      "
                                      v-b-popover.hover.top="user.roleName"
                                    >
                                      {{ user.roleName }}
                                    </td>
                                  </tr>
                                </div>
                                <div
                                  v-else
                                  class="
                                    unselected-folder unselected-folder-text
                                    d-flex
                                    align-items-center
                                    justify-content-center
                                  "
                                >
                                  <span v-if="modalType == 'selectpanel'"
                                    >No panelist found</span
                                  >
                                  <span v-else>No user found</span>
                                </div>
                              </tbody>
                            </table>
                          </div>
                        </template>

                        <template v-else>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-center
                            "
                            style="height: calc(100vh - 330px)"
                          >
                            <img
                              src="../../assets/img/createjd/modalnouser.svg"
                              alt=""
                            />
                          </div>
                        </template>
                      </b-tab>
                    </b-tabs>
                  </b-overlay>
                </div>
              </template>
              <div
                v-if="
                  (checkEmptySelection && modalType == 'selectpanel') ||
                  (Object.keys(activeFolder).length > 0 &&
                    modalType == 'selectpanel')
                "
              >
                <div class="tp-side-modal-card-1 mt-3">
                  <div class="tp-top-card"></div>
                  <div class="p-2">
                    <div class="tp-card-head">Selected Panelist</div>

                    <div
                      class="tp-side-modal-below-card mt-1"
                      v-if="
                        !showPanelCard && Object.keys(selectedpanel).length != 0
                      "
                    >
                      <div
                        class="
                          d-flex
                          p-2
                          align-items-center
                          justify-content-between
                          tp-below-text
                        "
                      >
                        <div class="text-truncate" style="width: 50%">
                          <div class="ellipsis tp-below-text">
                            {{ selectedpanel.name }}
                          </div>
                        </div>
                        <div class="text-truncate" style="width: 50%">
                          <div class="ellipsis tp-text-1">
                            {{ selectedpanel.email }}
                          </div>
                        </div>

                        <div
                          class="text-center pointer table-data text-truncate"
                          v-b-popover.hover.top="selectedpanel.roleName"
                        >
                          {{ selectedpanel.roleName }}
                        </div>
                        <span class="pointer" @click="closePanelCard">
                          <img src="../../assets/panelist-cancel.svg" alt="" />
                        </span>
                      </div>
                      <div class="path-text p-1 ml-1" v-if="finalPath">
                        Teams: {{ finalPath }}
                      </div>
                    </div>
                    <div class="tp-side-modal-below-card mt-1" v-else>
                      <div
                        class="
                          d-flex
                          p-2
                          align-items-center
                          justify-content-between
                          tp-below-text
                        "
                      >
                        <div>No Panelist Selected</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </template>

        <template v-else>
          <div v-if="globalUsersList.length > 0" class="global-head"></div>
          <b-overlay :show="globalSpinner" rounded="sm">
            <div class="table-main mt-2">
              <table :aria-describedby="'Path'" class="w-100 tp-reports-table">
                <thead>
                  <tr>
                    <th style="width: 5%" class="text-center"></th>
                    <th style="width: 20%; text-align: left" class="table-data">
                      User Name
                    </th>
                    <th
                      style="width: 20%; text-align: center"
                      class="table-data"
                    >
                      Email ID
                    </th>
                    <th
                      style="width: 20%; text-align: center"
                      class="table-data"
                    >
                      Roles
                    </th>
                    <th
                      style="width: 35%; text-align: center"
                      class="table-data"
                    >
                      Folder Path
                    </th>
                  </tr>
                </thead>

                <tbody style="height: calc(100vh - 320px)">
                  <div v-if="globalUsersList.length > 0">
                    <tr
                      v-for="(user, index) in globalUsersList"
                      :key="index"
                      :class="{
                        pointer:
                          modalType == 'selectpanel' || modalType == 'User',
                        'fm-selcetd-class':
                          (modalType == 'selectpanel' &&
                            user.panelID == selectedpanel.panelID &&
                            user.folderID === selectedpanel.folderID) ||
                          (modalType == 'User' &&
                            user.userID === selectedUserDetails.userID),
                        'fm-deselect-class pointer':
                          selectedpanel.panelID !== user.panelID,
                      }"
                      @click="
                        modalType === 'selectpanel' || modalType == 'User'
                          ? addPanel(user)
                          : ''
                      "
                    >
                      <td class="text-center table-data" style="width: 5%">
                        <div
                          :style="{
                            background: '#49BE9B',
                          }"
                          class="gridgreencolorDynamic mr-1"
                        ></div>
                        <b-form-checkbox
                          v-show="
                            modalType !== 'selectpanel' && modalType !== 'User'
                          "
                          size="sm"
                          :value="convertJSONtoString(user)"
                          v-model="selectedUsers"
                          @change="checkGlobalUser(user)"
                        ></b-form-checkbox>
                      </td>
                      <td
                        style="width: 20%; text-align: left"
                        class="table-data"
                      >
                        {{ user.username }}
                      </td>
                      <td
                        style="width: 20%; text-align: center"
                        class="table-data"
                      >
                        {{ user.email }}
                      </td>
                      <td
                        style="width: 20%; text-align: center"
                        class="table-data text-truncate"
                      >
                        <div v-b-popover.hover.top="user.roleName">
                          {{ user.roleName }}
                        </div>
                      </td>
                      <td
                        style="width: 35%; text-align: center"
                        class="table-data text-truncate"
                      >
                        Teams: {{ getFolderPath(user.parentFolder)
                        }}{{ user.folderName }}
                      </td>
                    </tr>
                  </div>
                  <div v-else>
                    <tr
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        no-users-teams
                      "
                    >
                      <span v-if="modalType == 'selectpanel'"
                        >No panelist found</span
                      >
                      <span v-else>No users found</span>
                    </tr>
                  </div>
                </tbody>
              </table>
            </div>
          </b-overlay>
        </template>
      </div>
      <hr />
      <div
        class="d-flex align-items-center justify-content-end"
        v-if="modalType == 'Recruiter' || modalType == 'Panelists'"
      >
        <b-button
          class="addbtn pr-4 pl-4"
          :class="selectedUsers.length === 0 ? 'global-disabledField' : ''"
          @click="saveSelectedData"
          :disabled="selectedUsers.length === 0"
        >
          {{ "Add " + getModalHeading }}
        </b-button>
      </div>
      <div
        class="d-flex align-items-center justify-content-end"
        v-else-if="modalType == 'selectpanel'"
      >
        <b-button
          class="addbtn pr-4 pl-4"
          :disabled="Object.keys(selectedpanel).length === 0"
          @click="closingmodal()"
        >
          Add Panelist
        </b-button>
      </div>
      <div
        class="d-flex align-items-center justify-content-end"
        v-if="modalType == 'User'"
      >
        <b-button
          class="addbtn pr-4 pl-4"
          :class="
            selectedUserDetails.userID === '' ||
            creatorID === selectedUserDetails.userID ||
            assigneeID === selectedUserDetails.userID
              ? 'global-disabledField'
              : ''
          "
          @click="assignTheTask"
          :disabled="
            selectedUserDetails.userID === '' ||
            creatorID === selectedUserDetails.userID ||
            assigneeID === selectedUserDetails.userID
          "
        >
          Assign the task
        </b-button>
      </div>
      <div
        v-if="modalType === 'User' && creatorID === selectedUserDetails.userID"
        class="caution-message mt-2"
      >
        You cannot assign this task to its creator. Please reassign it to
        another user.
      </div>
      <div
        v-else-if="
          modalType === 'User' && assigneeID === selectedUserDetails.userID
        "
        class="caution-message mt-2"
      >
        You cannot assign this task to yourself. Please reassign it to another
        user.
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getFolderDetails,
  getPanelist,
  getSelctedPanelist,
  getGlobalUsers,
  getGlobalPanelist,
} from "../../utils/apiFunctions";
import errorModal from "../../components/mixin/toast";

import FolderCard from "./FolderCard.vue";

export default {
  name: "FolderModal",
  props: {
    myMethod: {
      type: Function,
    },
    selectedPanelProp: Object,
    showModal: Boolean,
    clearDetails: Boolean,
    userList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    folderIDList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    creatorID: String,
    assigneeID: String,
  },
  components: {
    FolderCard,
  },
  mixins: [errorModal],
  data() {
    return {
      searchFolders: "",
      searchSubFolder: "",
      searchUser: "",
      timer: null,
      searchUserGlobal: "",
      folderSelectionState: "",
      selectAllGlobalUsers: false,
      globalSpinner: false,
      globalUsersList: [],
      selectedGlobalUsers: [],
      panelSelection: "",
      showLoader: false,
      folders: [],
      selectedParentFolders: [],
      showSpinner: false,
      stopSpinner: false,
      selectuserid: [],
      selectedFolderId: "",
      path: [],
      pathShow: "",
      Pathresult: "",
      finalPath: "",
      showPanelCard: false,
      selectedFolders: [],
      selectedUsers: [],
      activeFolderIdPan: "null",
      searchPan: "",
      searchPanUser: "",
      searchPanSubFolder: "",
      foldersListPan: [],
      folderUp: {},
      usersPan: [],
      selectedpanel: {},
      parentFolder: [],
      userPanel: "",
      selectedfolderId: "",
      selectUserid: [],
      convertJSONtoString: function (user) {
        return JSON.stringify({
          username: user.username,
          email: user.email,
          roleName: user.roleName,
          roles: user.roles,
          isActive: user.isActive,
          userID: user.userID,
          landingPage: user.landingPage,
          folderID: user.folderID,
        });
      },
      selectedUserDetails: {
        userID: "",
        email: "",
        role: "",
      },
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    ...mapGetters("folderVUEX", {
      folderExpandList: "getExpandList",
      activeFolder: "getActiveFolder",
      modalType: "getModalType",
      selectedUsersList: "getSelectedUsers",
      selectedFolderList: "getSelectedFolderIDs",
    }),
    checkEmptySelection() {
      return Object.keys(this.activeFolder).length === 0;
    },
    getIndex() {
      return this.folderExpandList.findIndex(
        (folder) => folder.folderID === this.folder.folderID
      );
    },
    getExactRole() {
      return this.modalType === "Recruiter"
        ? "GET_JOBDASHBOARD"
        : "GET_PANEL_DASHBOARD";
    },
    getModalHeading() {
      if (this.modalType === "Recruiter") {
        return "Recruiters";
      } else if (
        this.modalType === "Panelists" ||
        this.modalType === "selectpanel"
      ) {
        return "Panelist";
      } else if (this.modalType === "User") {
        return "User";
      } else return "Panelist";
    },
  },
  watch: {
    showModal() {
      if (
        this.showModal &&
        ["Recruiter", "Panelists", "User"].includes(this.modalType)
      ) {
        this.getAllFolders();
        this.showSpinner = true;
        this.selectedParentFolders = this.selectedFolderList;
        this.selectedUsers = this.selectedUsersList;
      } else if (this.showModal && this.modalType == "selectpanel") {
        this.getPanelists();
        this.showSpinner = true;
        this.selectedUsers = this.selectedUsersList;
      }
    },
    selectedPanelProp(newValue, oldValue) {
      if (newValue != oldValue) {
        this.selectedpanel = newValue;
        this.selectedFolderId = this.selectedpanel.folderID;
        this.selectuserid.push(this.selectedpanel.panelUserID);
      }
    },

    clearDetails() {
      if (this.clearDetails) {
        this.clearPanel();
      }
    },
  },

  methods: {
    updateFolderUp(folderUp) {
      this.folderUp = folderUp;
    },
    assignTheTask() {
      if (this.selectedUserDetails.userID != "") {
        this.$emit("pass-userID", this.selectedUserDetails);
      }
      this.$emit("close-modal");
    },
    searchFolder() {
      this.folders = [];
      this.foldersListPan = [];
      this.$store.commit("folderVUEX/resetExpand");
      this.$store.commit("folderVUEX/setActiveFolder", {});
      this.$store.commit("folderVUEX/setActiveFolderID", "");
      this.showLoader = true;
      this.getAllFolders();
    },
    folderSearch() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.page = 1;
        this.getPanelists();
      }, 400);
    },
    getFolderPath: function (parentFolder) {
      let path = "";
      for (let folder in parentFolder) {
        path += parentFolder[folder].folderName + "\\";
      }
      return path;
    },
    checkGlobalUser(user) {
      let userObj = this.convertJSONtoString(user);
      if (!this.selectedUsers.includes(userObj)) {
        let index = this.selectedParentFolders.indexOf(user.folderID);
        if (index !== -1) {
          this.selectedParentFolders.splice(index, 1);
        }
      } else {
        this.findByUser(user.folderID, false);
      }
    },
    async getGlobalUsers() {
      if (this.modalType !== "selectpanel") {
        this.globalSpinner = true;
      }
      if (this.showModal) {
        try {
          let payload = {
            project: "recruitment",
            licenseKey: this.getlicenseKey,
            exactRole: this.getExactRole,
            searchUser: this.searchUserGlobal,
          };
          let response;
          if (this.modalType === "selectpanel") {
            this.showSpinner = true;
            payload.assaignedPanelists = this.userList;
            response = await getGlobalPanelist(payload);
          } else if (this.modalType === "User") {
            let data = {
              project: "recruitment",
              licenseKey: this.getlicenseKey,
              searchUser: this.searchUserGlobal,
            };
            response = await getGlobalUsers(data);
          } else {
            response = await getGlobalUsers(payload);
          }

          if (response.status == 200) {
            this.globalUsersList = response.data.data.data;
            this.showSpinner = false;
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.globalSpinner = false;
        }
      }
    },

    showfolderspinner(data) {
      this.stopSpinner = data;
    },

    clearPanel() {
      this.selectedpanel = {};
      this.finalPath = "";
      this.$emit("clearObject");
    },

    closingmodal() {
      this.$emit("close-modal");
      this.$emit("myMethod", this.selectedpanel);
      this.searchPan = "";
      this.searchSubFolder = "";
      this.searchUser = "";
      this.searchUserGlobal = "";
    },
    addPanel(user) {
      if (this.modalType == "selectpanel") {
        this.selectedpanel = user;
        if (!Object.hasOwn(this.selectedpanel, "name")) {
          this.selectedpanel.name = user.username;
        }
        this.selectUserid.push(user.userID);
        this.selectedfolderId = user.folderID;
        this.selectactiveuserId = user.userID;
        this.getSelctedPanelist();
      } else {
        this.selectedUserDetails.userID = user.userID;
        this.selectedUserDetails.email = user.email;
        this.selectedUserDetails.role = user.roleName;
      }
    },
    closePanelCard() {
      this.$nextTick(() => {
        this.selectedpanel = {};
        this.searchUserGlobal = "";
      });
    },
    async getPanelists() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          searchFolder: this.searchPan,
          searchUser: this.searchUser,
          searchSubFolder: this.searchSubFolder,
        };
        const response = await getPanelist(payload);
        if (response.status == 200) {
          this.showSpinner = false;

          this.foldersListPan = response.data.data.tree;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async checkFolderCard(folderID) {
      let index = this.selectedParentFolders.findIndex(
        (folder) => folder === folderID
      );
      if (index === -1) {
        this.selectedParentFolders.push(folderID);
        if (folderID === this.activeFolder.folderID) {
          this.checkSelectAll();
        } else {
          const response = await this.getFolderDetails(folderID, true);
          let users = response.data.data.content.users;
          let set = new Set(this.selectedUsers);
          this.folderUp = response.data.data.folderUp;

          users.forEach((user) => {
            let userObj = this.convertJSONtoString(user);
            set.add(userObj);
          });
          this.selectedUsers = [];
          set.forEach((user) => this.selectedUsers.push(user));
        }
      } else {
        this.selectedParentFolders.splice(index, 1);
        if (folderID === this.activeFolder.folderID) {
          this.checkSelectAll();
        } else {
          const response = await this.getFolderDetails(folderID, true);
          let users = response.data.data.content.users;
          this.folderUp = response.data.data.folderUp;
          for (let user in users) {
            let userObj = this.convertJSONtoString(users[user]);
            let position = this.selectedUsers.indexOf(userObj);
            if (position != -1) {
              this.selectedUsers.splice(position, 1);
            }
          }
        }
      }
    },
    closeModal() {
      this.$emit("close-modal");
      this.searchFolders = "";
      this.searchUserGlobal = "";
    },
    checkUsers(users, folderID) {
      if (users.length > 0) {
        let set = new Set(this.selectedUsers);
        let flag = true;
        for (let user in users) {
          let userObj = this.convertJSONtoString(users[user]);
          if (!set.has(userObj)) {
            flag = false;
            break;
          }
        }
        if (flag) {
          if (!this.selectedParentFolders.includes(folderID)) {
            this.selectedParentFolders.push(folderID);
            this.folderSelectionState = "add";
          }
        } else {
          let index = this.selectedParentFolders.findIndex(
            (folderId) => folderID === folderId
          );
          this.selectedParentFolders.splice(index, 1);
          this.folderSelectionState = "remove";
        }
      }
    },
    checkSelectAll() {
      let set = new Set(this.selectedParentFolders);
      if (set.has(this.activeFolder.folderID)) {
        this.folderSelectionState = "add";
        this.activeFolder.users.forEach((user) => {
          let currentUser = this.convertJSONtoString(user);
          if (!this.selectedUsers.includes(currentUser)) {
            this.selectedUsers.push(currentUser);
          }
        });
      } else {
        this.folderSelectionState = "remove";
        for (let i in this.activeFolder.users) {
          let user = this.convertJSONtoString(this.activeFolder.users[i]);
          for (let j in this.selectedUsers) {
            if (this.selectedUsers[j] === user) {
              this.selectedUsers.splice(j, 1);
              break;
            }
          }
        }
      }
    },
    saveSelectedData() {
      this.$store.commit("folderVUEX/saveSelectedUsers", this.selectedUsers);
      this.$store.commit(
        "folderVUEX/saveSelectedFolders",
        this.selectedParentFolders
      );
      this.selectedParentFolders = [];
      this.selectedUsers = [];
      if (this.getModalHeading === "Recruiters") {
        this.$emit("save-recruiters");
      } else {
        this.$emit("save-panelists");
      }
      this.searchFolders = "";
      this.searchUserGlobal = "";
    },

    async getAllFolders() {
      let payload = {};
      try {
        if (this.modalType === "User") {
          payload = {
            project: "recruitment",
            licenseKey: this.getlicenseKey,
            searchFolder: this.searchFolders,
            searchUser: this.searchUserGlobal,
          };
        } else {
          payload = {
            project: "recruitment",
            licenseKey: this.getlicenseKey,
            exactRole: this.getExactRole,
            searchFolder: this.searchFolders,
            searchUser: this.searchUserGlobal,
          };
        }
        const response = await getFolderDetails(payload);
        if (response.status == 200) {
          this.showSpinner = false;
          if (this.modalType === "User") {
            this.foldersListPan = response.data.data.tree;
          } else {
            this.folders = response.data.data.tree;
          }
        }
        this.showLoader = false;
      } catch (error) {
        console.error(error);
        this.showLoader = false;
      }
    },

    async findByUser(folderID, flag) {
      this.stopSpinner = true;
      try {
        const response = await this.getFolderDetails(folderID, flag);
        if (response.status == 200) {
          let users = response.data.data.content.users;
          if (flag) {
            this.activeFolder.users = users;
          }
          this.checkUsers(users, folderID);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.stopSpinner = false;
      }
    },

    async findByFolder() {
      this.stopSpinner = true;

      const response = await this.getFolderDetails(
        this.activeFolder.folderID,
        true
      );
      this.activeFolder.childFolders = response.data.data.content.childFolders;
      this.stopSpinner = false;
    },

    async getSelctedPanelist() {
      this.Pathresult = "";
      this.finalPath = "";
      if (Object.keys(this.selectedPanelProp).length != 0) {
        try {
          let payload = {
            project: "recruitment",
            licenseKey: this.getlicenseKey,
            userList: this.selectuserid,
            folderID: this.selectedFolderId,
          };
          const res = await getSelctedPanelist(payload);
          this.path = res.data.data.data;
          for (let i = 0; i < this.path[0].parentFolder.length; i++) {
            this.Pathresult += this.path[0].parentFolder[i].folderName;
            if (i < this.path[0].parentFolder.length) {
              this.Pathresult += "\\";
            }
          }
          this.finalPath = this.Pathresult + this.path[0].folderName;
        } catch (error) {
          console.error(error);
        }
      }
    },

    async getFolderDetails(folderID, flag) {
      if (this.modalType == "Recruiter" || this.modalType === "Panelists") {
        try {
          let payload = {
            project: "recruitment",
            licenseKey: this.getlicenseKey,
            folderID: folderID,
            exactRole: this.getExactRole,
            searchUser: this.searchUser,
            searchSubFolder: this.searchSubFolder,
          };
          if (flag) {
            payload.flag = flag;
          }
          const response = await this.$store.dispatch(
            "folderVUEX/getSelectedFolder",
            payload
          );
          this.folderUp = response.data.data.folderUp;
          if (!flag) {
            this.setActive(folderID);
          }
          return response;
        } catch (error) {
          console.error(error);
        }
      } else if (this.modalType == "selectpanel") {
        return this.getPanelDetails(folderID, flag);
      } else if (this.modalType === "User") {
        return this.getUserDetails(folderID, flag);
      }
    },
    async getPanelDetails(folderID, flag) {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          searchFolder: this.searchPan,
          folderID: folderID,
          searchUser: this.searchUser,
          searchSubFolder: this.searchSubFolder,
        };
        if (flag) {
          payload.flag = flag;
        }
        const response = await this.$store.dispatch(
          "folderVUEX/getPanelists",
          payload
        );
        this.folderUp = response.data.data.folderUp;
        if (!flag) {
          this.setActive(folderID);
        }
        return response;
      } catch (error) {
        console.error(error);
      }
    },

    async getUserDetails(folderID, flag) {
      try {
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          folderID: folderID,
          searchUser: this.searchUser,
          searchSubFolder: this.searchSubFolder,
        };
        if (flag) {
          payload.flag = flag;
        }
        const response = await this.$store.dispatch(
          "folderVUEX/getSelectedFolder",
          payload
        );
        this.folderUp = response.data.data.folderUp;
        if (!flag) {
          this.setActive(folderID);
        }
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    setActive(folderId) {
      this.$store.commit("folderVUEX/setActiveFolderID", folderId);
      let index = this.folderExpandList.findIndex(
        (folder) => folder.folderID === folderId
      );
      this.$store.commit("folderVUEX/flipExpand", {
        index,
        flag: true,
      });
    },
  },
};
</script>

<style>
.unselected-folder-text {
  font-weight: 500;
  font-size: 14px;
  color: #696969;
}
.unselected-folder {
  background: #fcfcfc;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}
.no-folder-card {
  background: #fcfcfc;
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
  font-weight: 500;
  font-size: 14px;
  color: #696969;
  display: flex;
  align-items: center;
  justify-content: center;
}
.global-head {
  color: #72738e;
  font-weight: 500;
  font-size: 14px;
}
.no-users-teams {
  font-weight: 500;
  font-size: 13px;
  color: #696969;
}
.folder-count-text {
  font-weight: 500;
  font-size: 12px;
  color: #464667;
}
.folder-label-text {
  font-weight: 400;
  font-size: 12px;
  color: #696969;
}
.table-data {
  vertical-align: middle;
  width: 30%;
}
.folder-list-name {
  font-weight: 400;
  font-size: 13px;
  color: #696969;
}

.folder-box {
  padding: 10px;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.folder-content-list {
  padding: 5px;
  overflow: auto;
  height: calc(100vh - 430px);
}
.folder-card-list {
  padding: 5px;
  overflow: auto;
  height: calc(100vh - 479px);
}
.path-folder-card {
  padding: 5px;
  overflow: auto;
  height: calc(100vh - 505px);
}

.tag-user {
  font-size: 14px;
  font-size: 500;
  color: #72738e;
}

.search-bar-popup-folders {
  position: relative;
  width: 100%;
}
.search-bar-popup-folders .searchicon {
  position: absolute;
  top: 10px;
  left: 10px;
}

.search-bar-popup-folders .search-input {
  height: 34px;
  background: #ffffff;
  border: 0.5px solid #c4c4c4;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0 30px !important;
  width: 100%;
}

.folders-left-container {
  background: #f3f3f3;
  height: calc(100vh - 276px) !important;

  width: 100%;
  overflow: auto;
  padding: 15px;
}

.active-folder {
  color: #72738e;
  font-weight: 500;
  font-size: 14px;
}

.access-control-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  font-size: 14px;
  color: #72738e;
}

.access-control-tabs a {
  color: #495057;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
}

.access-control-tabs li {
  width: 150px;
  text-align: center;
  /* border-bottom: 1px solid #72738e; */
}
.selected-card-color {
  background: #fcfcfc;
}

.access-control-tabs .nav-tabs .nav-link {
  border: unset;
}

.access-control-tabs a:hover {
  color: #495057;
}

.access-control-tabs .nav-tabs {
  border-bottom: unset;
}

.access-control-tabs .nav-link {
  display: block;
  padding: 0.5rem 0rem;
}
.selected-panel-card {
  height: 109px;

  background: #ffffff;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

.jd-topbar {
  height: 10px;

  background: #9dd49a;
  border-radius: 3px 3px 0px 0px;
}
.access-control-tabs .nav-tabs .nav-link.active {
  position: relative;
  border-bottom: 4px solid #72738e;
}
.fm-belowcard {
  padding: 12px;

  background: #eeeeee;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}
.select-panel-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;

  color: #696969;
}
.tp-side-modal-card-1 {
  background: #eeeeee;
  border-radius: 5px;
}
.tp-top-card {
  height: 10px;
  background: #9dd49a;
  border-radius: 5px 5px 0px 0px;
}
.tp-card-head {
  font-size: 14px;
  font-weight: 600;
  color: #696969;
}
.tp-side-modal-below-card {
  min-height: auto;
  max-height: calc(100vh - 597px);
  overflow: auto;
  background: #fbfbfb;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}
.path-text {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  color: #8b8b8b;
}
.tp-below-text {
  font-size: 14px;
  font-weight: 400;
  color: #696969;
}
.fm-deselect-class {
  background: #fcfcfc !important;
}
.fm-selcetd-class {
  background: #dee2e6 !important;
}
.table-panel-fm {
  height: calc(100vh - 529px) !important;
}
.table-panel-user {
  height: calc(100vh - 425px) !important;
}
.table-createjd {
  height: calc(100vh - 430px) !important;
}
.table-finalpath {
  height: calc(100vh - 555px) !important;
}
.empty-selction {
  height: calc(100vh - 263px) !important;
}
.empty-selection-panel {
  height: calc(100vh - 341px) !important;
}
.empty-path-selection {
  height: calc(100vh - 364px) !important;
}
.caution-message {
  color: red;
  text-align: right;
  font-size: 12px;
}
</style>
